export default function RefundPolicy() {
  return (
    <div style={{ padding: "20px" }}>
      <h2>Refund & Cancellation Policy</h2>
      <p>
        Refund and Cancellation Policy – Nawabi Bites

We want you to have a smooth shopping experience.

Cancellation Policy

Orders can be cancelled before dispatch only.

Once shipped, cancellation will not be possible.

Refund Policy

Refunds are given under the following conditions:

Wrong product delivered

Damaged or expired product

Missing items

To request a refund:

Email us at support@nawabibites.com
 within 24 hours of delivery.

Attach clear images of the product & invoice.

Non-Refundable Items

Opened food packets

Used, tampered, or consumed products

Items without original packaging

Refund Timeline

Approved refunds will be processed in 5–7 working days.
      </p>
    </div>
  );
}
